export const validateMobile = (value) => {
  const regex = /^\d{10}$/;
  return regex.test(value);
};
export const isValidEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
}


export const ageCalculate = (dob) => {
  if (dob) {
    const dobNew = new Date(dob);
    const today = new Date();

    return today.getFullYear() - dobNew.getFullYear();
  } else {
    return
  }
}

export const decimalToFeetInches = (decimalFeet) => {
  if (decimalFeet) {
    const feet = Math.floor(decimalFeet);
    const inches = Math.round((decimalFeet - feet) * 12);
    return `${feet} ft ${inches} in`;
  } else {
    return
  }
}

export const decimalToFeetInchesWithoutWord = (decimalFeet) => {
  if (decimalFeet) {
    const feet = Math.floor(decimalFeet);
    const inches = Math.round((decimalFeet - feet) * 12);
    return `${feet}' ${inches}"`;
  } else {
    return
  }
}


export function formatNumber(num) {
  if (num >= 10000000) return `${num / 10000000} Crore`;
  if (num >= 100000) return `${num / 100000} Lakh`;
  return num.toString();
}

export const formatIndianCurrencyRange = (input) => {
  //input = input.toLowerCase().trim();
  /* if(input !==''){
    
    if (input === "Not Applicable") return "Not Applicable";
  
    
    if (input.startsWith("Upto")) {
      const value = Number(input.replace("Upto", "").trim());
      return `Upto ${formatNumber(value)}`;
    }
  
    
    if (input.startsWith("Above")) {
      const value = Number(input.replace("Above", "").trim());
      return `Above ${formatNumber(value)}`;
    }
  
    
    if (input.includes("-")) {
      const [start, end] = input.split("-").map(Number);
      return `${formatNumber(start)} to ${formatNumber(end)}`;
    }
  
    
    const num = Number(input);
    return formatNumber(num);
  } else {
    return
  }
    */
}


export const maskMobileNumber = (number) => {
  if (!number) return "";
  const str = number.toString();
  const visibleDigits = 4;
  const maskedSection = "*".repeat(Math.max(str.length - visibleDigits, 0));
  const visibleSection = str.slice(-visibleDigits);
  return maskedSection + visibleSection;
};



export const maskEmail = (email) => {
  if (!email || !email.includes("@")) return email;
  const [localPart, domain] = email.split("@");
  const visible = localPart.slice(0, 2);
  return `${visible}${"*".repeat(Math.max(localPart.length - 2, 0))}@${domain}`;
}

export const decimaltocm = (value) => {
  if (!value) return "";
  let feet = Math.floor(value);
  let inches = (value - feet) * 10;

  let totalCm = Math.round((feet * 30.48) + (inches * 2.54));
  return totalCm + " cm";
  //console.log(totalCm.toFixed(2) + " cm");

}
export const decimaltoWithoutcm = (value) => {
  if (!value) return "";
  let feet = Math.floor(value);
  let inches = (value - feet) * 10;

  let totalCm = Math.round((feet * 30.48) + (inches * 2.54));
  return totalCm;
  //console.log(totalCm.toFixed(2) + " cm");

}


function parseIncomeRange(range) {
  // Handle null, undefined, or empty values
  if (!range || typeof range !== "string") {
    return { min: 0, max: Infinity, applicable: false };
  }

  // Handle "Not Applicable" case
  if (range.toLowerCase() === "Not Applicable") {
    return { min: 0, max: Infinity, applicable: false };
  }

  range = range.toLowerCase().trim();

  // Handle empty string after trim
  if (!range) {
    return { min: 0, max: Infinity, applicable: false };
  }

  // Handle "Above X" format
  if (range.startsWith("Above")) {
    const min = Number(range.replace(/[^\d]/g, "")) || 0;
    return { min, max: Infinity, applicable: true };
  }

  // Handle "X - Y" format
  const parts = range.split("-").map(v => v.trim());
  const minStr = parts[0];
  const maxStr = parts[1];

  // Validate that we have both parts
  if (!minStr || !maxStr) {
    return { min: 0, max: Infinity, applicable: false };
  }

  const min = Number(minStr.replace(/[^\d]/g, "")) || 0;
  const max = Number(maxStr.replace(/[^\d]/g, "")) || 0;

  return { min, max, applicable: true };
}

export const isIncomeRangeCompatible = (partnerRange, matchRange) => {
  // Add defensive checks for undefined/null values
  if (!partnerRange || !matchRange) {
    return true; // If either range is missing, consider it compatible
  }

  try {
    const partner = parseIncomeRange(partnerRange);
    const match = parseIncomeRange(matchRange);

    if (!partner.applicable || !match.applicable) return true;

    const overlap = match.max >= partner.min && match.min <= partner.max;
    return overlap;
  } catch (error) {
    console.error("Error checking income range compatibility:", error);
    return true; // Default to compatible on error
  }
}




export function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric"
  });
}

export function formatCount(num) {
  if (num === 0) return "0";
  return String(num).padStart(2, "0");
}

export const getImageUrl = (imagePath) => {
  if (!imagePath || typeof imagePath !== "string") {
    return `${process.env.PUBLIC_URL || ""}/assets/images/user-icon.png`;
  }

  const cleanPath = imagePath.trim();

  // 1. Full URL or Data URL
  if (cleanPath.startsWith("data:") || cleanPath.startsWith("http://") || cleanPath.startsWith("https://")) {
    return cleanPath;
  }

  const cdnBase = (
    process.env.REACT_APP_CDN_BASE_URL ||
    "https://cdn.vivashri.org"
  ).replace(/\/+$/, "");

  // Remove any leading slashes
  const normalizedKey = cleanPath.replace(/^\/+/, "");

  // If already prefixed with vivashri/
  if (normalizedKey.startsWith("vivashri/")) {
    return `${cdnBase}/${normalizedKey}`;
  }

  // If path starts with public/uploads/ -> convert to uploads/
  if (normalizedKey.startsWith("public/uploads/")) {
    return `${cdnBase}/vivashri/${normalizedKey.replace(/^public\//, "")}`;
  }

  // If path already starts with uploads/
  if (normalizedKey.startsWith("uploads/")) {
    return `${cdnBase}/vivashri/${normalizedKey}`;
  }

  // Default: treat as file in uploads/
  return `${cdnBase}/vivashri/uploads/${normalizedKey}`;
};




